import { createSlice, current } from '@reduxjs/toolkit';

const initialState = {
  configs: [
    {
      counts: {
        showColumns: [
          'OUTROS ESTOQUES',
          'REAL',
          'TEÓRICO',
          'ÚLTIMA',
          'CONSUMO',
          'DIFERENÇA EM QTDE / R$',
          'DIFERENÇA EM %',
          'USUÁRIO'
        ]
      }
    },
    {
      extracts: {
        showColumns: [
          'CUSTO',
          'VALOR',
          'QTDE FINAL',
          'VALOR FINAL',
        ]
      }
    },
    {
      menus: {
        showColumns: [
          'CARD. R$',
          'DESC.',
          'QTDE.',
          'TOTAL R$',
          'CUSTO TOTAL R$',
          'CUSTO NOMINAL',
          'CUSTO % PROJ.',
          'CUSTO % REAL'
        ]
      }
    },
    {
      production: {
        currentSquare: ''
      }
    },
    {
      duration: {
        showProjection: ''
      }
    },
    {
      mep: []
    },
  ],
};

export const userConfigs = createSlice({
  name: 'userConfig',
  initialState,
  reducers: {
    handleCountColumns: (state, action) => {
      const { payload } = action;
      const currState = current(state);
      const { configs } = payload;

      const newConfigs = configs?.find((config) => config?.counts)?.counts?.showColumns || currState.configs[0].counts.showColumns;

      localStorage.setItem('countConfigs', newConfigs);

      state.configs.find((config) => config.counts).counts.showColumns = newConfigs;
    },
    handleExtractDialogColumns: (state, action) => {
      const { payload } = action;
      const currState = current(state);
      const { configs } = payload;

      const newConfigs = configs?.find((config) => config?.extracts)?.extracts?.showColumns || currState.configs[0].extracts.showColumns;

      localStorage.setItem('extractDialogConfigs', newConfigs);

      state.configs.find((config) => config.extracts).extracts.showColumns = newConfigs;
    },
    handleMenusColumns: (state, action) => {
      const { payload } = action;
      const currState = current(state);
      const { configs } = payload;

      const newConfigs = configs?.find((config) => config?.menus)?.menus?.showColumns || currState.configs[0].menus.showColumns;

      localStorage.setItem('menusConfigs', newConfigs);

      state.configs.find((config) => config.menus).menus.showColumns = newConfigs;
    },
    handleProductionSquare: (state, action) => {
      const { payload } = action;
      const { configs } = payload;

      localStorage.setItem('productionConfigs', JSON.stringify(configs));

      state.configs.find((config) => config.production).production.currentSquare = configs;
    },
    setMepConfigs: (state, action) => {
      const mepIndex = state.configs.findIndex((config) => config.mep);
    
      if (mepIndex !== -1) {
        state.configs[mepIndex].mep = action.payload;
      } else {
        state.configs.push({ mep: action.payload });
      }
    
      localStorage.setItem('miseEnPlaceConfigs', JSON.stringify(action.payload));
    },
    updateMepConfig: (state, action) => {
      const { restaurantId, key, value, otherConfigs = {} } = action.payload;
    
      const mepConfigIndex = state.configs.findIndex(config => config.mep);
      
      if (mepConfigIndex === -1) {
        const newMepArray = [{
          restaurantId,
          courtDefault: otherConfigs.courtDefault || '',
          viewType: otherConfigs.viewType || [],
          listOrder: otherConfigs.listOrder || [],
          [key]: Array.isArray(value) ? [...value] : value
        }];
        state.configs.push({ mep: newMepArray });
        localStorage.setItem('miseEnPlaceConfigs', JSON.stringify(newMepArray));
        return;
      }
    
      const mepArray = [...state.configs[mepConfigIndex].mep];
      const existingIndex = mepArray.findIndex(cfg => cfg.restaurantId === restaurantId);
    
      const newConfig = {
        ...(mepArray[existingIndex] || {}),
        restaurantId,
        ...otherConfigs,
        [key]: Array.isArray(value) ? [...value] : value
      };
    
      if (existingIndex !== -1) {
        mepArray[existingIndex] = newConfig;
      } else {
        mepArray.push(newConfig);
      }
    
      state.configs[mepConfigIndex].mep = mepArray;
    
      localStorage.setItem('miseEnPlaceConfigs', JSON.stringify(mepArray));
    },
    handleShowSalesProjection: (state, action) => {
      const { payload } = action;
      const currState = current(state);
      const { configs } = payload;

      const newConfigs = configs.find((config) => config.duration)?.duration?.showProjection || currState?.configs[0].duration?.showProjection;

      localStorage.setItem('showProjectionConfigs', newConfigs);

      state.configs.find((config) => config?.duration).duration.showProjection = newConfigs;
    },

    clearAll: (state) => {
      state.products = [];
      state.selectedPages = [];
      state.mep = [];
    },
  }
});

export const {
  handleCountColumns,
  handleMenusColumns,
  handleExtractDialogColumns,
  handleProductionSquare,
  updateMepConfig,
  setMepConfigs,
  handleShowSalesProjection,
  clearAll
} = userConfigs.actions;

export default userConfigs.reducer;
